import React from "react";
import { createRoot } from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import "@sumprio/ui/styles";
import "@sumprio/ui/icons/styles";
import "./styles/sumprio-view-description.scss";
import "./index.scss";
import "./styles/ColorPicker.scss";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import * as serviceWorker from "./serviceWorker";
import { validateRuntimeEnv } from "./config/validateRuntimeEnv";

validateRuntimeEnv();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

createRoot(rootEl).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

serviceWorker.unregister();
